'use client'

import Image from 'next/image'
import PageBanner from '@/components/features/PageBanner'
import Link from 'next/link'
import { Home } from 'lucide-react'

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-gray-50 pt-24">
      <PageBanner 
        title="關於我們" 
        subtitle="了解更多關於本會的資訊"
      />
      
      <div className="container mx-auto px-4 py-12">
        <Link 
          href="/" 
          className="inline-flex items-center gap-2 mb-6 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
        >
          <Home className="w-4 h-4" />
          回首頁
        </Link>

        {/* 公會簡介 */}
        <section className="mb-20 bg-white rounded-lg shadow-sm p-8">
          <div className="flex flex-col lg:flex-row gap-8 items-center">
            <div className="lg:w-1/2">
              <h2 className="text-2xl font-semibold mb-6 flex items-center">
                <span className="w-2 h-8 bg-teal-500 mr-3"></span>
                公會簡介
              </h2>
              <div className="prose max-w-none text-gray-600">
                <p className="mb-4">
                  桃園市報關商業同業公會成立於民國111年，為桃園地區報關服務業之重要公會組織。
                </p>
                <p className="mb-4">
                  本會以促進報關服務業發展、維護同業合法權益、增進會員福利、提升服務品質為宗旨。
                </p>
                <p>
                  多年來致力於提供會員教育訓練、法諮詢、業務交流等服務，為桃園地區報關服務業的發展做出重要貢獻。
                </p>
              </div>
            </div>
            <div className="lg:w-1/2">
              <Image
                src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40"
                alt="公會簡介圖片"
                width={600}
                height={400}
                className="rounded-lg shadow-md"
              />
            </div>
          </div>
        </section>

        {/* 組織架構 */}
        <section className="mb-20 bg-white rounded-lg shadow-sm p-8">
          <h2 className="text-2xl font-semibold mb-8 flex items-center">
            <span className="w-2 h-8 bg-teal-500 mr-3"></span>
            組織架構
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { 
                title: '理事會', 
                members: [
                  '理事長 羅絜騫',
                  '常務理事 葉永照',
                  '常務理事 李承峰',
                  '理事 璩誌炘',
                  '理事 周士雯',
                  '理事 江衍智',
                  '理事 曹俊元',
                  '理事 蘇博宸',
                  '理事 黃皓軒'
                ] 
              },
              { 
                title: '監事會', 
                members: [
                  '常務監事 周春湖',
                  '監事 林政安',
                  '監事 游高彥'
                ] 
              },
              { 
                title: '秘書處', 
                members: [
                  '總幹事 黃騰昱',
                  '秘書 曾珮綺'
                ] 
              },
            ].map((group, index) => (
              <div key={index} className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-xl font-semibold mb-4 text-teal-600">{group.title}</h3>
                <ul className="space-y-2">
                  {group.members.map((member, idx) => (
                    <li key={idx} className="text-gray-600">{member}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        {/* 理事長的話 */}
        <section className="bg-white rounded-lg shadow-sm p-8">
          <h2 className="text-2xl font-semibold mb-8 flex items-center">
            <span className="w-2 h-8 bg-teal-500 mr-3"></span>
            理事長的話
          </h2>
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="md:w-1/3">
              <Image
                src="/images/chairman.jpg"
                alt="理事長照片"
                width={869}
                height={1882}
                className="rounded-lg shadow-md w-full h-auto"
              />
              <p className="text-center mt-4 font-semibold">羅絜騫 理事長</p>
            </div>
            <div className="md:w-2/3 prose max-w-none text-gray-600">
              <p className="mb-4 text-lg leading-relaxed">
                親愛的會員與各界先進：
              </p>
              <p className="mb-4">
                本會秉持服務的熱忱，持續為會員提供專業支援與服務...
              </p>
              {/* 可以添加更多內容 */}
            </div>
          </div>
        </section>
      </div>
    </div>
  )
} 
